import React from 'react';

export const Loading = () => (
    <div className='' style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100vw',
        zIndex: 10000,
    }}>
        <div id="loading" className="blackout" style={{
            background: 'rgba(0, 0, 0, 0.85)',
            height: '100vh',
            width: '100vw',
        }}>

        </div>
        <div className='position-absolute justify-content-center mx-auto d-flex flex-column align-items-center' style={{
            top: '45%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 10001,
        }}>
            <h4 className='mt-5 text-center'>Fetching Data, Please wait</h4>
            <img src="images/loading.gif" className='mx-auto' style={{
                width: '150px',
                height: '150px',
            }} />
        </div>
    </div>
)
export const LoadingSpinner = () => (
    <img src="images/loading.gif" className='w-100' />
)

export const LoadingGif = () => (
    <div className="w-100 loading-gif">
        <img src="images/loading.gif" className='w-100' />
    </div>
)